import { getUploadFn } from './upload';
import { canUseProxy } from './utils';
import time from './time';

class DataLayerListener {
  constructor(dataLayerName, uploadType) {
    this.dataLayerName = dataLayerName;
    this.uploadType = uploadType;
    this.deleteP = '';
    this.isProcessing = false; // 添加处理标志，避免重复处理
    this.uploadFn = null; // 缓存上传函数

    // 立即同步初始化 dataLayer，确保在任何埋点调用前已创建
    if (
      Object.prototype.toString.call(window[this.dataLayerName]) !==
      '[object Array]'
    ) {
      window[this.dataLayerName] = [];
    }

    this.init();
  }

  async init() {
    let _this = this;

    // 预加载上传函数，避免在 beforeunload 时异步加载
    this.uploadFn = await getUploadFn(this.uploadType);

    // 检查是否有待处理的埋点（dataLayer 已在构造函数中初始化）
    if (window[this.dataLayerName].length) {
      this.beginCheckDataLayer();
    }

    if (canUseProxy()) {
      window[this.dataLayerName] = new Proxy(window[this.dataLayerName], {
        set(target, property, value) {
          let isDeletePoint = property == 'length' && target.length > value;
          if (Object.prototype.toString.call(value) == '[object Object]') {
            let _time = time();
            value['pointDate'] = _time.pointDate;
            value['pointTime'] = _time.pointTime;
            value['pointTimestamp'] = _time.pointTimestamp;
          }
          target[property] = value;
          if (!isDeletePoint && property == 'length') {
            _this.beginCheckDataLayer();
          }
          return true;
        }
      });
    }

    // 页面卸载前，同步批量上报所有待处理的埋点
    window.addEventListener('beforeunload', () => {
      _this.flushAllPoints();
    });
  }

  /**
   * 批量上报所有待处理的埋点（同步处理，用于页面卸载场景）
   */
  flushAllPoints() {
    if (!this.uploadFn) {
      return;
    }
    // 批量处理所有待上报的埋点
    while (window[this.dataLayerName].length > 0) {
      let pointInfo = window[this.dataLayerName].shift();
      if (pointInfo) {
        try {
          // 直接同步调用上传函数，不使用 requestIdleCallback
          this.uploadFn(pointInfo, true); // 传入 true 表示强制使用 sendBeacon
        } catch (error) {
          console.error('BI point flush error:', error);
        }
      }
    }
  }

  async consumePoint(pointInfo) {
    if (!this.uploadFn) {
      this.uploadFn = await getUploadFn(this.uploadType);
    }

    if (!pointInfo) {
      return Promise.resolve();
    }

    return new Promise(async resolve => {
      // 正常场景：使用 requestIdleCallback 优化性能
      if (
        Object.prototype.toString.call(window.requestIdleCallback) ==
        '[object Function]'
      ) {
        window.requestIdleCallback(
          () => {
            this.uploadFn(pointInfo);
            resolve(void 0);
          },
          { timeout: 2000 }
        ); // 添加超时，确保埋点会被处理
      } else {
        this.uploadFn(pointInfo);
        resolve(void 0);
      }
    });
  }

  async beginCheckDataLayer() {
    // 避免重复处理
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;

    try {
      // 批量处理多个埋点，提高效率
      while (window[this.dataLayerName].length > 0) {
        let pointInfo = window[this.dataLayerName].shift();
        await this.consumePoint(pointInfo);
      }
    } catch (error) {
      console.error('BI point process error:', error);
    } finally {
      this.isProcessing = false;

      // 双重检查：释放锁后再次检查是否有新数据进来
      // 避免在 while 结束到 finally 期间 push 的数据被遗漏
      if (window[this.dataLayerName].length > 0) {
        // 使用 setTimeout 避免递归调用栈过深
        setTimeout(() => this.beginCheckDataLayer(), 0);
      }
    }
  }
}

export default DataLayerListener;
